// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import '../Styles/Home.css';
// import {
//   FiDollarSign,
//   FiTrendingUp,
//   FiShoppingCart,
//   FiTruck,
//   FiSettings,
//   FiCheckCircle,
//   FiUsers,
//   FiLogOut,
//   FiMenu,
// } from 'react-icons/fi';
// import { Icon, addCollection } from '@iconify/react';
// import flatColorData from '@iconify-json/flat-color-icons/icons.json';
// // import logo from '../Images/SAVI AI -1.png';
// // import SaviHalfLogo from '../Images/savilogo - Copy.png';
// import logo from '../Images/SAVI AI full.png';
// import SaviHalfLogo from '../Images/SAVI AI Halff.png';

// addCollection(flatColorData);

// const functionalAreas = [
//   {
//     id: 1,
//     name: 'Finance',
//     icon: <FiDollarSign />,
//     color: '#1565C0',
//     bg: '#E3F2FD',
//     description: 'Automate financial processes and improve accuracy',
//     useCases: [
//       { name: 'Vendor Invoice Automation', cardIcon: 'flat-color-icons:paid',        description: 'Automatically process and validate vendor invoices with AI' },
//       { name: 'GR/IR reconciliation',      cardIcon: 'flat-color-icons:synchronize', description: 'Match goods receipts with invoice receipts seamlessly' },
//       { name: 'Journal entry automation',  cardIcon: 'flat-color-icons:edit-image',  description: 'Automate journal entries and reduce manual data entry' },
//       { name: 'Expense audit automation',  cardIcon: 'flat-color-icons:inspection',  description: 'Intelligent expense auditing and compliance checking' },
//       { name: 'Finance Balances',           cardIcon: 'flat-color-icons:combo-chart', description: 'Ledger, vendor, and customer balance analytics with AI-driven insights' },
//     ],
//   },
//   {
//     id: 2,
//     name: 'Sales',
//     icon: <FiTrendingUp />,
//     color: '#00695C',
//     bg: '#E0F2F1',
//     description: 'Boost sales performance with AI-driven insights',
//     useCases: [
//       { name: 'CRM 360',            cardIcon: 'flat-color-icons:contacts',   description: 'Complete 360-degree view of customer relationships' },
//       { name: 'Order fulfillment',  cardIcon: 'flat-color-icons:shipped',    description: 'Streamline order processing and fulfillment workflows' },
//       { name: 'Sales forecasting',  cardIcon: 'flat-color-icons:statistics', description: 'Predict sales trends with advanced analytics' },
//       { name: 'Sentiment monitoring', cardIcon: 'flat-color-icons:feedback', description: 'Monitor customer sentiment across all touchpoints' },
//     ],
//   },
//   {
//     id: 3,
//     name: 'Procurement',
//     icon: <FiShoppingCart />,
//     color: '#E65100',
//     bg: '#FFF3E0',
//     description: 'Optimize procurement and vendor management',
//     useCases: [
//       { name: 'Automated PO creation',        cardIcon: 'flat-color-icons:document',          description: 'Generate purchase orders automatically based on demand' },
//       { name: 'Vendor performance analytics', cardIcon: 'flat-color-icons:combo-chart',       description: 'Track and analyze vendor performance metrics' },
//       { name: 'Price variance detection',     cardIcon: 'flat-color-icons:currency-exchange', description: 'Identify and alert on price discrepancies' },
//       { name: 'Contract extraction',          cardIcon: 'flat-color-icons:reading',           description: 'Extract key terms and clauses from contracts' },
//     ],
//   },
//   {
//     id: 4,
//     name: 'Supply Chain',
//     icon: <FiTruck />,
//     color: '#558B2F',
//     bg: '#F1F8E9',
//     description: 'Enhance supply chain visibility and efficiency',
//     useCases: [
//       { name: 'Inventory optimization',   cardIcon: 'flat-color-icons:database',  description: 'Optimize inventory levels and reduce carrying costs' },
//       { name: 'Demand forecasting',       cardIcon: 'flat-color-icons:mind-map',  description: 'Forecast demand accurately to prevent stockouts' },
//       { name: 'Auto reorder triggers',    cardIcon: 'flat-color-icons:workflow',  description: 'Automatic reordering based on inventory thresholds' },
//       { name: 'Delivery delay prediction', cardIcon: 'flat-color-icons:alarm-clock', description: 'Predict and mitigate potential delivery delays' },
//     ],
//   },
//   {
//     id: 5,
//     name: 'Manufacturing',
//     icon: <FiSettings />,
//     color: '#1B5E20',
//     bg: '#E8F5E9',
//     description: 'Optimize manufacturing operations and productivity',
//     useCases: [
//       { name: 'Production plan optimization', cardIcon: 'flat-color-icons:timeline',     description: 'Optimize production schedules for maximum efficiency' },
//       { name: 'Downtime prediction',          cardIcon: 'flat-color-icons:factory-breakdown', description: 'Predict equipment failures before they occur' },
//       { name: 'Material usage forecasting',   cardIcon: 'flat-color-icons:factory',      description: 'Forecast material requirements accurately' },
//       { name: 'Shop floor insights',          cardIcon: 'flat-color-icons:electronics',  description: 'Real-time visibility into shop floor operations' },
//     ],
//   },
//   {
//     id: 6,
//     name: 'Quality',
//     icon: <FiCheckCircle />,
//     color: '#0D47A1',
//     bg: '#E3F2FD',
//     description: 'Ensure quality standards and compliance',
//     useCases: [
//       { name: 'QC data analysis',        cardIcon: 'flat-color-icons:heat-map',   description: 'Analyze quality control data for insights' },
//       { name: 'Defect detection',        cardIcon: 'flat-color-icons:search',     description: 'AI-powered defect detection and classification' },
//       { name: 'Root cause insights',     cardIcon: 'flat-color-icons:mind-map',   description: 'Identify root causes of quality issues' },
//       { name: 'Certificate verification', cardIcon: 'flat-color-icons:diploma-1',  description: 'Verify certificates and compliance documents' },
//     ],
//   },
//   {
//     id: 7,
//     name: 'CRM',
//     icon: <FiUsers />,
//     color: '#00695C',
//     bg: '#E0F2F1',
//     description: 'Transform customer relationships and engagement',
//     useCases: [
//       { name: '360° customer insights', cardIcon: 'flat-color-icons:customer-support', description: 'Complete view of customer interactions and history' },
//       { name: 'Churn prediction',       cardIcon: 'flat-color-icons:broken-link',     description: 'Predict and prevent customer churn proactively' },
//       { name: 'Upsell/cross-sell AI',   cardIcon: 'flat-color-icons:money-transfer',  description: 'AI-driven recommendations for upsell opportunities' },
//       { name: 'Automated responses',    cardIcon: 'flat-color-icons:voice-presentation', description: 'Intelligent automated customer responses' },
//     ],
//   },
// ];

// const Home = () => {
//   const navigate = useNavigate();
//   const userName = localStorage.getItem('user') || 'User';
//   const userInitial = userName.charAt(0).toUpperCase();
//   const [comingSoon, setComingSoon] = useState('');
//   const [selectedArea, setSelectedArea] = useState(null);
//   const [isSidebarActive, setIsSidebarActive] = useState(true);

//   const navItemBase = {
//     display: 'flex', alignItems: 'center', gap: '10px',
//     height: '38px', padding: '0 12px', margin: '0',
//     fontSize: '14px', fontWeight: 400, lineHeight: '1',
//     background: 'none', border: 'none', borderRadius: '4px',
//     width: '100%', cursor: 'pointer', textAlign: 'left',
//     color: '#242424', boxSizing: 'border-box',
//   };
//   const navItemActive = {
//     ...navItemBase,
//     background: '#ffffff', borderLeft: '3px solid #5b5fc7',
//     borderRadius: '0 4px 4px 0', padding: '0 12px 0 9px',
//     fontWeight: 600, boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
//   };

//   const toggleSidebar = () => {
//     setIsSidebarActive(!isSidebarActive);
//   };

//   const handleAreaClick = (area) => {
//     setSelectedArea(area);
//     if (window.innerWidth <= 426) {
//       setIsSidebarActive(false);
//     }
//   };

//   const handleHomeClick = () => {
//     setSelectedArea(null);
//     if (window.innerWidth <= 426) {
//       setIsSidebarActive(false);
//     }
//   };

//   const handleUseCaseClick = (useCase) => {
//     if (useCase === 'Vendor Invoice Automation') {
//       navigate('/vendor-login');
//       return;
//     }
//     if (useCase === 'PO Automation' || useCase === 'poautomation') {
//       navigate('/procure-ai');
//       return;
//     }
//     if (useCase === 'Automated PO creation') {
//       navigate('/procure-ai');
//       return;
//     }
//     if (useCase === 'NPD Drawing Assistant') {
//       navigate('/npd');
//       return;
//     }
//     if (useCase === 'GR/IR reconciliation') {
//       navigate('/grir');
//       return;
//     }
//     if (useCase === 'Order fulfillment') {
//       navigate('/order-fulfillment');
//       return;
//     }
//     if (useCase === 'O2C agent') {
//       navigate('/o2c-agent/upload');
//       return;
//     }
//     if (useCase === 'Sentiment monitoring') {
//       navigate('/sentiment');
//       return;
//     }
//     if (useCase === 'Inventory optimization') {
//       navigate('/inventory');
//       return;
//     }
//     if (useCase === 'Journal entry automation') {
//       navigate('/journal');
//       return;
//     }
//     if (useCase === 'Sales forecasting') {
//       navigate('/sales-forecasting');
//       return;
//     }
//     if (useCase === 'Finance Balances') {
//       navigate('/finance-balances');
//       return;
//     }
//     if (useCase === 'Expense Policy Enforcement' || useCase === 'Expense audit automation') {
//       navigate('/expense');
//       return;
//     }
//     // Not yet implemented
//     setComingSoon(useCase);
//     setTimeout(() => setComingSoon(''), 2500);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('isAuthenticated');
//     localStorage.removeItem('user');
//     localStorage.removeItem('userType');
//     localStorage.removeItem('authMethod');
//     navigate('/', { replace: true });
//   };

//   // Built by SAVIC default cards
//   const builtBySAVIC = [
//     {
//       name: 'Vendor Invoice Automation',
//       cardIcon: 'flat-color-icons:paid',
//       description: 'Automatically process and validate vendor invoices with AI',
//     },
//     {
//       name: 'PO Automation',
//       cardIcon: 'flat-color-icons:document',
//       description: 'Automate purchase order creation and procurement workflows',
//     },
//     {
//       name: 'NPD Drawing Assistant',
//       cardIcon: 'flat-color-icons:engineering',
//       description: 'Upload fastener drawing PDFs, extract specs, and generate DXF output',
//     },
//     {
//       name: 'GR/IR reconciliation',
//       cardIcon: 'flat-color-icons:synchronize',
//       description: 'Match goods receipts with invoice receipts seamlessly',
//     },
//     {
//       name: 'Order fulfillment',
//       cardIcon: 'flat-color-icons:shipped',
//       description: 'Streamline order processing and fulfillment workflows',
//     },
//     {
//       name: 'O2C agent',
//       cardIcon: 'flat-color-icons:workflow',
//       description: 'Ingest PO PDFs, confirm extraction, process orders, and manage approvals',
//     },
//     {
//       name: 'Sentiment monitoring',
//       cardIcon: 'flat-color-icons:feedback',
//       description: 'Monitor customer sentiment, detect churn signals, and auto-escalate P1 alerts',
//     },
//     {
//       name: 'Journal entry automation',
//       cardIcon: 'flat-color-icons:edit-image',
//       description: 'Submit, validate, and post journal entries with multi-tier approval workflows',
//     },
//     {
//       name: 'Inventory optimization',
//       cardIcon: 'flat-color-icons:database',
//       description: 'Real-time stock monitoring, demand forecasting, and automated purchase order creation',
//     },
//     {
//       name: 'Finance Balances',
//       cardIcon: 'flat-color-icons:combo-chart',
//       description: 'Ledger, vendor, and customer balance analytics with AI-driven insights',
//     },
//     {
//       name: 'Sales forecasting',
//       cardIcon: 'flat-color-icons:statistics',
//       description: 'AI-driven revenue forecasts, quota management, and performance tracking',
//     },
//     {
//       name: 'Expense Policy Enforcement',
//       cardIcon: 'flat-color-icons:inspection',
//       description: 'Submit expense claims, enforce policy rules, manage approvals, and post to SAP automatically',
//     },
//   ];

//   const builtForSKS = [
//     {
//       name: 'GR/IR reconciliation',
//       cardIcon: 'flat-color-icons:synchronize',
//       description: 'Match goods receipts with invoice receipts seamlessly',
//     },
//   ];

//   const builtForMaxivision = [
//     {
//       name: 'GR/IR reconciliation',
//       cardIcon: 'flat-color-icons:synchronize',
//       description: 'Match goods receipts with invoice receipts seamlessly',
//     },
//   ];

//   const builtForNilons = [
//     {
//       name: 'GR/IR reconciliation',
//       cardIcon: 'flat-color-icons:synchronize',
//       description: 'Match goods receipts with invoice receipts seamlessly',
//     },
//   ];

//   const AgentCard = ({ card, onClick }) => (
//     <motion.div
//       className="agent-card"
//       onClick={() => onClick(card.name)}
//       variants={{
//         hidden: { opacity: 0, y: 20, scale: 0.95 },
//         visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 100, damping: 15 } }
//       }}
//       whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.2 } }}
//       whileTap={{ scale: 0.98 }}
//     >
//       <motion.div
//         className="agent-icon"
//         whileHover={{ rotate: [0, -10, 10, -10, 0], scale: 1.1 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Icon icon={card.cardIcon} width={36} height={36} />
//       </motion.div>
//       <div className="agent-content">
//         <h3 className="agent-title">{card.name}</h3>
//         <p className="agent-description">{card.description}</p>
//       </div>
//     </motion.div>
//   );

//   return (
//     <div className="home-container">
//       {/* Sidebar */}
//       {isSidebarActive && window.innerWidth <= 426 && (
//         <div
//           className="sidebar-overlay"
//           onClick={toggleSidebar}
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             zIndex: 998,
//             background: 'rgba(0, 0, 0, 0.25)',
//           }}
//         />
//       )}
//       <div className={`sidebar ${isSidebarActive ? 'active' : 'collapsed'}`}>
//         <div className="hamburger-menu-container">
//           <div className="hamburger-menu" onClick={toggleSidebar}>
//             <button className="menu-btn">
//               <FiMenu size={20} />
//             </button>
//           </div>
//           {!isSidebarActive && (
//             <div
//               className="logo-container1"
//               onClick={toggleSidebar}
//               style={{ cursor: 'pointer' }}
//             >
//               <img
//                 src={SaviHalfLogo}
//                 alt="SAVI Half Logo"
//                 style={{ width: 30, height: 30 }}
//               />
//             </div>
//           )}
//           <div
//             className="logo-container2"
//             onClick={handleHomeClick}
//             style={{ cursor: 'pointer' }}
//           >
//             <img src={logo} alt="SAVI Logo" style={{ width: 53, height: 19 }} />
//           </div>
//         </div>

//         <div className="sidebar-section1">
//           <h3 className="section-title">Agents</h3>
//           <nav className="sidebar-nav home-sidebar-nav" style={{ display: 'block', padding: 0, margin: 0 }}>
//             <button
//               className={`nav-btn home-nav-btn ${selectedArea ? '' : 'active'}`}
//               onClick={handleHomeClick}
//               title="All agents"
//               style={selectedArea ? navItemBase : navItemActive}
//             >
//               <FiUsers size={16} />
//               {isSidebarActive && <span>All agents</span>}
//             </button>
//             {functionalAreas.map((area) => {
//               const isActive = selectedArea?.id === area.id;
//               return (
//                 <button
//                   key={area.id}
//                   className={`nav-btn home-nav-btn ${isActive ? 'active' : ''}`}
//                   onClick={() => handleAreaClick(area)}
//                   title={area.name}
//                   style={isActive ? navItemActive : navItemBase}
//                 >
//                   <span className="nav-area-icon">{area.icon}</span>
//                   {isSidebarActive && <span>{area.name}</span>}
//                 </button>
//               );
//             })}
//           </nav>
//         </div>

//         <div className="sidebar-footer">
//           {isSidebarActive ? (
//             <>
//               <div className="sidebar-user-section">
//                 <div className="user-badge">
//                   <div className="user-avatar">{userInitial}</div>
//                   <span className="user-name">{userName}</span>
//                 </div>
//               </div>
//               <button className="footer-btn" onClick={handleLogout} title="Logout">
//                 <FiLogOut size={16} />
//                 <span>Logout</span>
//               </button>
//             </>
//           ) : (
//             <button className="footer-btn" onClick={handleLogout} title="Logout">
//               <FiLogOut size={16} />
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Main content */}
//       <div className="home-main-wrapper">
//         <motion.main 
//           className="home-main"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.4 }}
//         >
//           <motion.div 
//             className="home-main-inner"
//             initial={{ y: 20, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//           >
//             {/* Page title */}
//             <motion.div 
//               className="page-title-wrapper"
//               initial={{ x: -20, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <h1 className="page-title">
//                 {selectedArea ? selectedArea.name : 'Agents'}
//               </h1>
//             </motion.div>

//             {/* Section heading (functional area view) */}
//             <AnimatePresence mode="wait">
//               {selectedArea && (
//                 <motion.div
//                   className="section-block"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   transition={{ duration: 0.3 }}
//                   key={selectedArea.id}
//                 >
//                   <h2 className="section-heading">{selectedArea.description}</h2>
//                 </motion.div>
//               )}
//             </AnimatePresence>

//             {/* Functional area cards */}
//             {selectedArea && (
//               <motion.div
//                 className="agent-grid"
//                 initial="hidden"
//                 animate="visible"
//                 variants={{
//                   hidden: { opacity: 0 },
//                   visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.3 } }
//                 }}
//                 key={selectedArea.id}
//               >
//                 {selectedArea.useCases.map((card, index) => (
//                   <AgentCard key={`${card.name}-${index}`} card={card} onClick={handleUseCaseClick} />
//                 ))}
//               </motion.div>
//             )}

//             {/* All-agents view: three labelled sections */}
//             {!selectedArea && (
//               <>
//                 <motion.div
//                   className="section-block"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <h2 className="section-heading">Built by SAVIC</h2>
//                 </motion.div>
//                 <motion.div
//                   className="agent-grid"
//                   initial="hidden"
//                   animate="visible"
//                   variants={{
//                     hidden: { opacity: 0 },
//                     visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.2 } }
//                   }}
//                 >
//                   {builtBySAVIC.map((card, index) => (
//                     <AgentCard key={`savic-${card.name}-${index}`} card={card} onClick={handleUseCaseClick} />
//                   ))}
//                 </motion.div>

//                 <motion.div
//                   className="section-block"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.3, delay: 0.1 }}
//                   style={{ marginTop: '2rem' }}
//                 >
//                   <h2 className="section-heading">Built for SKS</h2>
//                 </motion.div>
//                 <motion.div
//                   className="agent-grid"
//                   initial="hidden"
//                   animate="visible"
//                   variants={{
//                     hidden: { opacity: 0 },
//                     visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.3 } }
//                   }}
//                 >
//                   {builtForSKS.map((card, index) => (
//                     <AgentCard
//                       key={`sks-${card.name}-${index}`}
//                       card={card}
//                       onClick={() => navigate('/grir-sks')}
//                     />
//                   ))}
//                 </motion.div>

//                 <motion.div
//                   className="section-block"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.3, delay: 0.2 }}
//                   style={{ marginTop: '2rem' }}
//                 >
//                   <h2 className="section-heading">Built for Maxivision</h2>
//                 </motion.div>
//                 <motion.div
//                   className="agent-grid"
//                   initial="hidden"
//                   animate="visible"
//                   variants={{
//                     hidden: { opacity: 0 },
//                     visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.4 } }
//                   }}
//                 >
//                   {builtForMaxivision.map((card, index) => (
//                     <AgentCard
//                       key={`maxivision-${card.name}-${index}`}
//                       card={card}
//                       onClick={(name) => {
//                         setComingSoon(name);
//                         setTimeout(() => setComingSoon(''), 2500);
//                       }}
//                     />
//                   ))}
//                 </motion.div>

//                 <motion.div
//                   className="section-block"
//                   initial={{ opacity: 0, y: -10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.3, delay: 0.3 }}
//                   style={{ marginTop: '2rem' }}
//                 >
//                   <h2 className="section-heading">Built for Nilons</h2>
//                 </motion.div>
//                 <motion.div
//                   className="agent-grid"
//                   initial="hidden"
//                   animate="visible"
//                   variants={{
//                     hidden: { opacity: 0 },
//                     visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.5 } }
//                   }}
//                 >
//                   {builtForNilons.map((card, index) => (
//                     <AgentCard
//                       key={`nilons-${card.name}-${index}`}
//                       card={card}
//                       onClick={(name) => {
//                         setComingSoon(name);
//                         setTimeout(() => setComingSoon(''), 2500);
//                       }}
//                     />
//                   ))}
//                 </motion.div>
//               </>
//             )}
//           </motion.div>
//         </motion.main>
//       </div>

//       {/* Coming soon toast */}
//       <AnimatePresence>
//         {comingSoon && (
//           <motion.div 
//             className="coming-soon-toast"
//             initial={{ opacity: 0, y: 50, scale: 0.9 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 20, scale: 0.95 }}
//             transition={{ type: "spring", stiffness: 200, damping: 20 }}
//           >
//             <strong>"{comingSoon}"</strong> — Coming soon!
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default Home;



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import '../Styles/Home.css';
import {
  FiDollarSign,
  FiTrendingUp,
  FiShoppingCart,
  FiTruck,
  FiSettings,
  FiCheckCircle,
  FiUsers,
  FiLogOut,
  FiMenu,
  FiBarChart2,
  FiArrowLeft,
} from 'react-icons/fi';
import { Icon, addCollection } from '@iconify/react';
import flatColorData from '@iconify-json/flat-color-icons/icons.json';
// import logo from '../Images/SAVI AI -1.png';
// import SaviHalfLogo from '../Images/savilogo - Copy.png';
import logo from '../Images/SAVI AI full.png';
import SaviHalfLogo from '../Images/SAVI AI Halff.png';
import dashboardGroups from './dashboardsData';

addCollection(flatColorData);

const functionalAreas = [
  {
    id: 1,
    name: 'Finance',
    icon: <FiDollarSign />,
    color: '#1565C0',
    bg: '#E3F2FD',
    description: 'Automate financial processes and improve accuracy',
    useCases: [
      { name: 'Vendor Invoice Automation', cardIcon: 'flat-color-icons:paid',        description: 'Automatically process and validate vendor invoices with AI' },
      { name: 'GR/IR reconciliation',      cardIcon: 'flat-color-icons:synchronize', description: 'Match goods receipts with invoice receipts seamlessly' },
      { name: 'Journal entry automation',  cardIcon: 'flat-color-icons:edit-image',  description: 'Automate journal entries and reduce manual data entry' },
      { name: 'Expense audit automation',  cardIcon: 'flat-color-icons:inspection',  description: 'Intelligent expense auditing and compliance checking' },
      { name: 'Finance Balances',           cardIcon: 'flat-color-icons:combo-chart', description: 'Ledger, vendor, and customer balance analytics with AI-driven insights' },
    ],
  },
  {
    id: 2,
    name: 'Sales',
    icon: <FiTrendingUp />,
    color: '#00695C',
    bg: '#E0F2F1',
    description: 'Boost sales performance with AI-driven insights',
    useCases: [
      { name: 'CRM 360',            cardIcon: 'flat-color-icons:contacts',   description: 'Complete 360-degree view of customer relationships' },
      { name: 'Order fulfillment',  cardIcon: 'flat-color-icons:shipped',    description: 'Streamline order processing and fulfillment workflows' },
      { name: 'Sales forecasting',  cardIcon: 'flat-color-icons:statistics', description: 'Predict sales trends with advanced analytics' },
      { name: 'Sentiment monitoring', cardIcon: 'flat-color-icons:feedback', description: 'Monitor customer sentiment across all touchpoints' },
    ],
  },
  {
    id: 3,
    name: 'Procurement',
    icon: <FiShoppingCart />,
    color: '#E65100',
    bg: '#FFF3E0',
    description: 'Optimize procurement and vendor management',
    useCases: [
      { name: 'Automated PO creation',        cardIcon: 'flat-color-icons:document',          description: 'Generate purchase orders automatically based on demand' },
      { name: 'Vendor performance analytics', cardIcon: 'flat-color-icons:combo-chart',       description: 'Track and analyze vendor performance metrics' },
      { name: 'Price variance detection',     cardIcon: 'flat-color-icons:currency-exchange', description: 'Identify and alert on price discrepancies' },
      { name: 'Contract extraction',          cardIcon: 'flat-color-icons:reading',           description: 'Extract key terms and clauses from contracts' },
    ],
  },
  {
    id: 4,
    name: 'Supply Chain',
    icon: <FiTruck />,
    color: '#558B2F',
    bg: '#F1F8E9',
    description: 'Enhance supply chain visibility and efficiency',
    useCases: [
      { name: 'Inventory optimization',   cardIcon: 'flat-color-icons:database',  description: 'Optimize inventory levels and reduce carrying costs' },
      { name: 'Demand forecasting',       cardIcon: 'flat-color-icons:mind-map',  description: 'Forecast demand accurately to prevent stockouts' },
      { name: 'Auto reorder triggers',    cardIcon: 'flat-color-icons:workflow',  description: 'Automatic reordering based on inventory thresholds' },
      { name: 'Delivery delay prediction', cardIcon: 'flat-color-icons:alarm-clock', description: 'Predict and mitigate potential delivery delays' },
    ],
  },
  {
    id: 5,
    name: 'Manufacturing',
    icon: <FiSettings />,
    color: '#1B5E20',
    bg: '#E8F5E9',
    description: 'Optimize manufacturing operations and productivity',
    useCases: [
      { name: 'Production plan optimization', cardIcon: 'flat-color-icons:timeline',     description: 'Optimize production schedules for maximum efficiency' },
      { name: 'Downtime prediction',          cardIcon: 'flat-color-icons:factory-breakdown', description: 'Predict equipment failures before they occur' },
      { name: 'Material usage forecasting',   cardIcon: 'flat-color-icons:factory',      description: 'Forecast material requirements accurately' },
      { name: 'Shop floor insights',          cardIcon: 'flat-color-icons:electronics',  description: 'Real-time visibility into shop floor operations' },
    ],
  },
  {
    id: 6,
    name: 'Quality',
    icon: <FiCheckCircle />,
    color: '#0D47A1',
    bg: '#E3F2FD',
    description: 'Ensure quality standards and compliance',
    useCases: [
      { name: 'QC data analysis',        cardIcon: 'flat-color-icons:heat-map',   description: 'Analyze quality control data for insights' },
      { name: 'Defect detection',        cardIcon: 'flat-color-icons:search',     description: 'AI-powered defect detection and classification' },
      { name: 'Root cause insights',     cardIcon: 'flat-color-icons:mind-map',   description: 'Identify root causes of quality issues' },
      { name: 'Certificate verification', cardIcon: 'flat-color-icons:diploma-1',  description: 'Verify certificates and compliance documents' },
    ],
  },
  {
    id: 7,
    name: 'CRM',
    icon: <FiUsers />,
    color: '#00695C',
    bg: '#E0F2F1',
    description: 'Transform customer relationships and engagement',
    useCases: [
      { name: '360° customer insights', cardIcon: 'flat-color-icons:customer-support', description: 'Complete view of customer interactions and history' },
      { name: 'Churn prediction',       cardIcon: 'flat-color-icons:broken-link',     description: 'Predict and prevent customer churn proactively' },
      { name: 'Upsell/cross-sell AI',   cardIcon: 'flat-color-icons:money-transfer',  description: 'AI-driven recommendations for upsell opportunities' },
      { name: 'Automated responses',    cardIcon: 'flat-color-icons:voice-presentation', description: 'Intelligent automated customer responses' },
    ],
  },
];

const Home = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem('user') || 'User';
  const userInitial = userName.charAt(0).toUpperCase();
  const [comingSoon, setComingSoon] = useState('');
  const [selectedArea, setSelectedArea] = useState(null);
  const [isSidebarActive, setIsSidebarActive] = useState(true);
  // Dashboards section: `showDashboards` swaps the main area to the Power BI
  // catalogue; `openDashboard` holds the report currently rendered in the iframe.
  const [showDashboards, setShowDashboards] = useState(false);
  const [openDashboard, setOpenDashboard] = useState(null);

  const navItemBase = {
    display: 'flex', alignItems: 'center', gap: '10px',
    height: '38px', padding: '0 12px', margin: '0',
    fontSize: '14px', fontWeight: 400, lineHeight: '1',
    background: 'none', border: 'none', borderRadius: '4px',
    width: '100%', cursor: 'pointer', textAlign: 'left',
    color: '#242424', boxSizing: 'border-box',
  };
  const navItemActive = {
    ...navItemBase,
    background: '#ffffff', borderLeft: '3px solid #5b5fc7',
    borderRadius: '0 4px 4px 0', padding: '0 12px 0 9px',
    fontWeight: 600, boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  };

  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  const handleAreaClick = (area) => {
    setSelectedArea(area);
    setShowDashboards(false);
    setOpenDashboard(null);
    if (window.innerWidth <= 426) {
      setIsSidebarActive(false);
    }
  };

  const handleHomeClick = () => {
    setSelectedArea(null);
    setShowDashboards(false);
    setOpenDashboard(null);
    if (window.innerWidth <= 426) {
      setIsSidebarActive(false);
    }
  };

  const handleDashboardsClick = () => {
    setSelectedArea(null);
    setShowDashboards(true);
    setOpenDashboard(null);
    if (window.innerWidth <= 426) {
      setIsSidebarActive(false);
    }
  };

  const handleUseCaseClick = (useCase) => {
    if (useCase === 'Vendor Invoice Automation') {
      navigate('/vendor-login');
      return;
    }
    if (useCase === 'PO Automation' || useCase === 'poautomation') {
      navigate('/procure-ai');
      return;
    }
    if (useCase === 'Automated PO creation') {
      navigate('/procure-ai');
      return;
    }
    if (useCase === 'NPD Drawing Assistant') {
      navigate('/npd');
      return;
    }
    if (useCase === 'GR/IR reconciliation') {
      navigate('/grir');
      return;
    }
    if (useCase === 'Order fulfillment') {
      navigate('/order-fulfillment');
      return;
    }
    if (useCase === 'O2C agent') {
      navigate('/o2c-agent/upload');
      return;
    }
    if (useCase === 'Sentiment monitoring') {
      navigate('/sentiment');
      return;
    }
    if (useCase === 'Inventory optimization') {
      navigate('/inventory');
      return;
    }
    if (useCase === 'Journal entry automation') {
      navigate('/journal');
      return;
    }
    if (useCase === 'Sales forecasting') {
      navigate('/sales-forecasting');
      return;
    }
    if (useCase === 'Finance Balances') {
      navigate('/finance-balances');
      return;
    }
    if (useCase === 'Expense Policy Enforcement' || useCase === 'Expense audit automation') {
      navigate('/expense');
      return;
    }
    // Not yet implemented
    setComingSoon(useCase);
    setTimeout(() => setComingSoon(''), 2500);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('authMethod');
    navigate('/', { replace: true });
  };

  // Built by SAVIC default cards
  const builtBySAVIC = [
    {
      name: 'Vendor Invoice Automation',
      cardIcon: 'flat-color-icons:paid',
      description: 'Automatically process and validate vendor invoices with AI',
    },
    {
      name: 'PO Automation',
      cardIcon: 'flat-color-icons:document',
      description: 'Automate purchase order creation and procurement workflows',
    },
    {
      name: 'NPD Drawing Assistant',
      cardIcon: 'flat-color-icons:engineering',
      description: 'Upload fastener drawing PDFs, extract specs, and generate DXF output',
    },
    {
      name: 'GR/IR reconciliation',
      cardIcon: 'flat-color-icons:synchronize',
      description: 'Match goods receipts with invoice receipts seamlessly',
    },
    {
      name: 'Order fulfillment',
      cardIcon: 'flat-color-icons:shipped',
      description: 'Streamline order processing and fulfillment workflows',
    },
    {
      name: 'O2C agent',
      cardIcon: 'flat-color-icons:workflow',
      description: 'Ingest PO PDFs, confirm extraction, process orders, and manage approvals',
    },
    {
      name: 'Sentiment monitoring',
      cardIcon: 'flat-color-icons:feedback',
      description: 'Monitor customer sentiment, detect churn signals, and auto-escalate P1 alerts',
    },
    {
      name: 'Journal entry automation',
      cardIcon: 'flat-color-icons:edit-image',
      description: 'Submit, validate, and post journal entries with multi-tier approval workflows',
    },
    {
      name: 'Inventory optimization',
      cardIcon: 'flat-color-icons:database',
      description: 'Real-time stock monitoring, demand forecasting, and automated purchase order creation',
    },
    {
      name: 'Finance Balances',
      cardIcon: 'flat-color-icons:combo-chart',
      description: 'Ledger, vendor, and customer balance analytics with AI-driven insights',
    },
    {
      name: 'Sales forecasting',
      cardIcon: 'flat-color-icons:statistics',
      description: 'AI-driven revenue forecasts, quota management, and performance tracking',
    },
    {
      name: 'Expense Policy Enforcement',
      cardIcon: 'flat-color-icons:inspection',
      description: 'Submit expense claims, enforce policy rules, manage approvals, and post to SAP automatically',
    },
  ];

  const builtForSKS = [
    {
      name: 'GR/IR reconciliation',
      cardIcon: 'flat-color-icons:synchronize',
      description: 'Match goods receipts with invoice receipts seamlessly',
    },
  ];

  const builtForMaxivision = [
    {
      name: 'GR/IR reconciliation',
      cardIcon: 'flat-color-icons:synchronize',
      description: 'Match goods receipts with invoice receipts seamlessly',
    },
  ];

  const builtForNilons = [
    {
      name: 'GR/IR reconciliation',
      cardIcon: 'flat-color-icons:synchronize',
      description: 'Match goods receipts with invoice receipts seamlessly',
    },
  ];

  const AgentCard = ({ card, onClick }) => (
    <motion.div
      className="agent-card"
      onClick={() => onClick(card.name)}
      variants={{
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 100, damping: 15 } }
      }}
      whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.2 } }}
      whileTap={{ scale: 0.98 }}
    >
      <motion.div
        className="agent-icon"
        whileHover={{ rotate: [0, -10, 10, -10, 0], scale: 1.1 }}
        transition={{ duration: 0.5 }}
      >
        <Icon icon={card.cardIcon} width={36} height={36} />
      </motion.div>
      <div className="agent-content">
        <h3 className="agent-title">{card.name}</h3>
        <p className="agent-description">{card.description}</p>
      </div>
    </motion.div>
  );

  // Same card chrome as AgentCard, but hands the whole dashboard (name + url)
  // back to the click handler instead of just the name.
  const DashboardCard = ({ card, onClick }) => (
    <motion.div
      className="agent-card"
      onClick={() => onClick(card)}
      variants={{
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 100, damping: 15 } }
      }}
      whileHover={{ y: -6, scale: 1.02, transition: { duration: 0.2 } }}
      whileTap={{ scale: 0.98 }}
    >
      <motion.div
        className="agent-icon"
        whileHover={{ rotate: [0, -10, 10, -10, 0], scale: 1.1 }}
        transition={{ duration: 0.5 }}
      >
        <Icon icon={card.cardIcon} width={36} height={36} />
      </motion.div>
      <div className="agent-content">
        <h3 className="agent-title">{card.name}</h3>
        <p className="agent-description">{card.description}</p>
      </div>
    </motion.div>
  );

  return (
    <div className="home-container">
      {/* Sidebar */}
      {isSidebarActive && window.innerWidth <= 426 && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 998,
            background: 'rgba(0, 0, 0, 0.25)',
          }}
        />
      )}
      <div className={`sidebar ${isSidebarActive ? 'active' : 'collapsed'}`}>
        <div className="hamburger-menu-container">
          <div className="hamburger-menu" onClick={toggleSidebar}>
            <button className="menu-btn">
              <FiMenu size={20} />
            </button>
          </div>
          {!isSidebarActive && (
            <div
              className="logo-container1"
              onClick={toggleSidebar}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={SaviHalfLogo}
                alt="SAVI Half Logo"
                style={{ width: 30, height: 30 }}
              />
            </div>
          )}
          <div
            className="logo-container2"
            onClick={handleHomeClick}
            style={{ cursor: 'pointer' }}
          >
            <img src={logo} alt="SAVI Logo" style={{ width: 53, height: 19 }} />
          </div>
        </div>

        <div className="sidebar-section1">
          <h3 className="section-title">Agents</h3>
          <nav className="sidebar-nav home-sidebar-nav" style={{ display: 'block', padding: 0, margin: 0 }}>
            <button
              className={`nav-btn home-nav-btn ${!selectedArea && !showDashboards ? 'active' : ''}`}
              onClick={handleHomeClick}
              title="All agents"
              style={!selectedArea && !showDashboards ? navItemActive : navItemBase}
            >
              <FiUsers size={16} />
              {isSidebarActive && <span>All agents</span>}
            </button>
            {functionalAreas.map((area) => {
              const isActive = selectedArea?.id === area.id;
              return (
                <button
                  key={area.id}
                  className={`nav-btn home-nav-btn ${isActive ? 'active' : ''}`}
                  onClick={() => handleAreaClick(area)}
                  title={area.name}
                  style={isActive ? navItemActive : navItemBase}
                >
                  <span className="nav-area-icon">{area.icon}</span>
                  {isSidebarActive && <span>{area.name}</span>}
                </button>
              );
            })}
            <button
              className={`nav-btn home-nav-btn ${showDashboards ? 'active' : ''}`}
              onClick={handleDashboardsClick}
              title="Dashboards"
              style={showDashboards ? navItemActive : navItemBase}
            >
              <span className="nav-area-icon"><FiBarChart2 /></span>
              {isSidebarActive && <span>Dashboards</span>}
            </button>
          </nav>
        </div>

        <div className="sidebar-footer">
          {isSidebarActive ? (
            <>
              <div className="sidebar-user-section">
                <div className="user-badge">
                  <div className="user-avatar">{userInitial}</div>
                  <span className="user-name">{userName}</span>
                </div>
              </div>
              <button className="footer-btn" onClick={handleLogout} title="Logout">
                <FiLogOut size={16} />
                <span>Logout</span>
              </button>
            </>
          ) : (
            <button className="footer-btn" onClick={handleLogout} title="Logout">
              <FiLogOut size={16} />
            </button>
          )}
        </div>
      </div>

      {/* Main content */}
      <div className="home-main-wrapper">
        <motion.main 
          className="home-main"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <motion.div 
            className="home-main-inner"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            {/* Power BI report view — replaces the whole page while a report is open */}
            {openDashboard && (
              <motion.div
                className="dashboard-view"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className="dashboard-view-header">
                  <button
                    className="dashboard-back-btn"
                    onClick={() => setOpenDashboard(null)}
                    title="Back to Dashboards"
                  >
                    <FiArrowLeft size={16} />
                    <span>Back to Dashboards</span>
                  </button>
                  <div className="dashboard-view-titles">
                    <h1 className="page-title">{openDashboard.name}</h1>
                    <span className="dashboard-view-persona">{openDashboard.persona}</span>
                  </div>
                </div>
                <div className="dashboard-frame-wrapper">
                  <iframe
                    key={openDashboard.url}
                    title={openDashboard.name}
                    src={openDashboard.url}
                    className="dashboard-frame"
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              </motion.div>
            )}

            {/* Page title */}
            {!openDashboard && (
              <motion.div
                className="page-title-wrapper"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h1 className="page-title">
                  {showDashboards ? 'Dashboards' : selectedArea ? selectedArea.name : 'Agents'}
                </h1>
              </motion.div>
            )}

            {/* Dashboards catalogue — persona-wise tile sections */}
            {showDashboards && !openDashboard && dashboardGroups.map((group, groupIndex) => (
              <div key={group.persona}>
                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: groupIndex * 0.1 }}
                  style={groupIndex > 0 ? { marginTop: '2rem' } : undefined}
                >
                  <h2 className="section-heading">{group.persona}</h2>
                </motion.div>
                <motion.div
                  className="agent-grid"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.06, delayChildren: 0.15 + groupIndex * 0.1 } }
                  }}
                >
                  {group.dashboards.map((card, index) => (
                    <DashboardCard
                      key={`${group.persona}-${card.name}-${index}`}
                      card={card}
                      onClick={(dash) => setOpenDashboard({ ...dash, persona: group.persona })}
                    />
                  ))}
                </motion.div>
              </div>
            ))}

            {/* Section heading (functional area view) */}
            <AnimatePresence mode="wait">
              {selectedArea && !openDashboard && (
                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  key={selectedArea.id}
                >
                  <h2 className="section-heading">{selectedArea.description}</h2>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Functional area cards */}
            {selectedArea && !openDashboard && (
              <motion.div
                className="agent-grid"
                initial="hidden"
                animate="visible"
                variants={{
                  hidden: { opacity: 0 },
                  visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.3 } }
                }}
                key={selectedArea.id}
              >
                {selectedArea.useCases.map((card, index) => (
                  <AgentCard key={`${card.name}-${index}`} card={card} onClick={handleUseCaseClick} />
                ))}
              </motion.div>
            )}

            {/* All-agents view: three labelled sections */}
            {!selectedArea && !showDashboards && !openDashboard && (
              <>
                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <h2 className="section-heading">Built by SAVIC</h2>
                </motion.div>
                <motion.div
                  className="agent-grid"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.2 } }
                  }}
                >
                  {builtBySAVIC.map((card, index) => (
                    <AgentCard key={`savic-${card.name}-${index}`} card={card} onClick={handleUseCaseClick} />
                  ))}
                </motion.div>

                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.1 }}
                  style={{ marginTop: '2rem' }}
                >
                  <h2 className="section-heading">Built for SKS</h2>
                </motion.div>
                <motion.div
                  className="agent-grid"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.3 } }
                  }}
                >
                  {builtForSKS.map((card, index) => (
                    <AgentCard
                      key={`sks-${card.name}-${index}`}
                      card={card}
                      onClick={() => navigate('/grir-sks')}
                    />
                  ))}
                </motion.div>

                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.2 }}
                  style={{ marginTop: '2rem' }}
                >
                  <h2 className="section-heading">Built for Maxivision</h2>
                </motion.div>
                <motion.div
                  className="agent-grid"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.4 } }
                  }}
                >
                  {builtForMaxivision.map((card, index) => (
                    <AgentCard
                      key={`maxivision-${card.name}-${index}`}
                      card={card}
                      onClick={(name) => {
                        setComingSoon(name);
                        setTimeout(() => setComingSoon(''), 2500);
                      }}
                    />
                  ))}
                </motion.div>

                <motion.div
                  className="section-block"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.3 }}
                  style={{ marginTop: '2rem' }}
                >
                  <h2 className="section-heading">Built for Nilons</h2>
                </motion.div>
                <motion.div
                  className="agent-grid"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.5 } }
                  }}
                >
                  {builtForNilons.map((card, index) => (
                    <AgentCard
                      key={`nilons-${card.name}-${index}`}
                      card={card}
                      onClick={(name) => {
                        setComingSoon(name);
                        setTimeout(() => setComingSoon(''), 2500);
                      }}
                    />
                  ))}
                </motion.div>
              </>
            )}
          </motion.div>
        </motion.main>
      </div>

      {/* Coming soon toast */}
      <AnimatePresence>
        {comingSoon && (
          <motion.div 
            className="coming-soon-toast"
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <strong>"{comingSoon}"</strong> — Coming soon!
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Home;